import { Component } from '@angular/core';

@Component({
  selector: 'app-example-page-two',
  templateUrl: './example-page-two.component.html',
  styleUrls: ['./example-page-two.component.scss'],
  imports: [],
})
export class ExamplePageTwoComponent {}
